import {ReactNode} from "react";
import styled from "@yb/styled-px2rem";
import SpriteImage from "@PUBLIC/M/images/ico/ico_spr.png";

interface WarningProps {
	children: ReactNode;
}

const Box = styled.div`
	display: flex;
	padding: 60px 0;
	text-align: center;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	gap: 20px;

	&:before {
		display: block;
		width: 45px;
		height: 45px;
		background: url(${SpriteImage}) -47px 0px / 300px 300px no-repeat;
		content: "";
	}

	p {
		font-size: 15px;
		color: var(--emp-color);
	}
`;

const WarningBox = ({children}: WarningProps) => (
	<Box>
		<p>{children}</p>
	</Box>
);

export default WarningBox;
